export { default as BannerProjects } from './images/bannerProjects.png';
export { default as BannerWelcomes } from './images/bannerWelcome.png';
export { default as IconBathroom } from './images/iconBathroom.png';
export { default as IconBedroom } from './images/iconBedroom.png';
export { default as IconDone } from './images/iconDone.png';
export { default as IconDrawer } from './images/iconDrawer.png';
export { default as IconEmail } from './images/iconeEmail.png';
export { default as IconFacebook } from './images/iconFacebook.png';
export { default as IconHome } from './images/iconHome.png';
export { default as IconHomeBlack } from './images/iconHomeBlack.png';
export { default as IconInstagram } from './images/iconInstagram.png';
export { default as IconLinkedin } from './images/iconLinkedin.png';
export { default as IconLocation } from './images/iconLocation.png';
export { default as IconSize } from './images/iconSize.png';
export { default as IconTelephone } from './images/iconTelephone.png';
export { default as IconTwitter } from './images/iconTwitter.png';
export { default as IconVacancies } from './images/iconVacancies.png';
export { default as IconWhatsapp } from './images/iconWhatsapp.png';
export { default as IconYoutube } from './images/iconYoutube.png';
export { default as SemFoto } from './images/sem_foto.png';
export { default as IconThreads } from './images/threads.png';
export { default as IconTiktok } from './images/tiktok.png';
export { default as ImagemMapa } from './images/ver_mapa.png';

